import { render, staticRenderFns } from "./SelectWrapper.vue?vue&type=template&id=521d2854&scoped=true"
var script = {}
import style0 from "./SelectWrapper.vue?vue&type=style&index=0&id=521d2854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521d2854",
  null
  
)

export default component.exports